export default __webpack_public_path__ + "static/media/cluster_point_gray.c3afccf7.svg";